import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const BookingSummary = ({ formData }) => {
  const { t } = useTranslation();

  return (
    <Card
      className="bg-white border-0 shadow-lg sticky top-48"
      data-testid="price-summary-card"
    >
      <CardHeader className="bg-[#3D405B] text-white rounded-t-lg">
        <CardTitle className="flex items-center gap-2 text-xl">
          <img src="/logo.svg" alt="Djohomi Foods" className="w-6 h-6 object-contain" />
          {t("booking.summary.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 space-y-4">
        <div className="border-b border-gray-100 pb-4">
          <p className="text-sm text-[#6B705C]">
            {formData.guest_count} {t("booking.summary.guests")}
          </p>
        </div>
        <div className="space-y-2 text-sm">
          {formData.event_date && (
            <div className="flex justify-between">
              <span className="text-[#6B705C]">{t("booking.summary.date")}</span>
              <span className="text-[#3D405B]">{formData.event_date}</span>
            </div>
          )}
          {formData.event_type && (
            <div className="flex justify-between">
              <span className="text-[#6B705C]">{t("booking.summary.event")}</span>
              <span className="text-[#3D405B]">{formData.event_type}</span>
            </div>
          )}
        </div>
        <div className="border-t border-gray-100 pt-4">
          <p className="text-sm text-[#6B705C] leading-relaxed">
            {t("booking.summary.pricingNote")}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default BookingSummary;
